<template>
    <div>
        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item label="昵称">
                <el-input placeholder="昵称" v-model="filter.nickname"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input placeholder="手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="用户id">
                <el-input placeholder="用户id" v-model.number="filter.userId"></el-input>
            </el-form-item>
            <el-form-item label="简历完成度">
                <el-select v-model="filter.complete">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="完成度为0%" :value="0"></el-option>
                    <el-option label="完成度为17%" :value="17"></el-option>
                    <el-option label="完成度为33%" :value="33"></el-option>
                    <el-option label="完成度为50%" :value="50"></el-option>
                    <el-option label="完成度为67%" :value="67"></el-option>
                    <el-option label="完成度为83%" :value="83"></el-option>
                    <el-option label="完成度为100%" :value="100"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否有头像">
                <el-select v-model="filter.isAvatar">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作类别">
                <el-select v-model="filter.workType">
                    <el-option value="" label="全部"></el-option>
                    <el-option v-for="(worCat,key1) in WorkCateList" :key="key1" :value="worCat.id" :label="worCat.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作经验">
                <el-select v-model="filter.workExperience" placeholder="工作经验">
                    <el-option value="" label="全部"></el-option>
                    <el-option :value="1" label="一年以下"></el-option>
                    <el-option :value="2" label="1-3年"></el-option>
                    <el-option :value="3" label="3-5年"></el-option>
                    <el-option :value="4" label="5-10年"></el-option>
                    <el-option :value="5" label="10年以上"></el-option>
                </el-select>
            </el-form-item>
            <!--
            <el-form-item label="可工作时间段">
                <el-select v-model="filter.workTime" placeholder="可工作时间段">
                    <el-option value="" label="全部"></el-option>
                    <el-option :value="1" label="周一至周五上午"></el-option>
                    <el-option :value="2" label="周一至周五下午"></el-option>
                    <el-option :value="3" label="周一至周五晚上"></el-option>
                    <el-option :value="4" label="周六上午"></el-option>
                    <el-option :value="5" label="周六下午"></el-option>
                    <el-option :value="6" label="周六晚上"></el-option>
                    <el-option :value="7" label="周日上午"></el-option>
                    <el-option :value="8" label="周日下午"></el-option>
                    <el-option :value="9" label="周日晚上"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作时薪 从">
                <el-input placeholder="工作时薪" v-model="filter.hourWageStart"></el-input>
            </el-form-item>
            <el-form-item label="到">
                <el-input placeholder="工作时薪" v-model="filter.hourWageEnd"></el-input>
            </el-form-item>
            <el-form-item label="投递数量 从">
                <el-input placeholder="投递数量" v-model="filter.quoteStart"></el-input>
            </el-form-item>
            <el-form-item label="到">
                <el-input placeholder="投递数量" v-model="filter.quoteEnd"></el-input>
            </el-form-item>
            -->
            <el-form-item label="职位头衔">
                <el-input placeholder="职位头衔" v-model="filter.jobTitle"></el-input>
            </el-form-item>
            <el-form-item label="工作单位">
                <el-input placeholder="工作单位" v-model="filter.corporateName"></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
                <el-input placeholder="项目名称" v-model="filter.projectName"></el-input>
            </el-form-item>
            <el-form-item label="学历">
                <el-select v-model="filter.degree" placeholder="学历">
                    <el-option value="" label="全部"></el-option>
                    <el-option :value="0" label="大专"></el-option>
                    <el-option :value="1" label="本科"></el-option>
                    <el-option :value="2" label="硕士"></el-option>
                    <el-option :value="3" label="博士"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属职业">
                <el-select v-model="filter.skillsTagId" placeholder="所属职业">
                    <el-option value="" label="全部"></el-option>
                    <el-option v-for="skill in skillsTags" :key="skill.id" :value="skill.id" :label="skill.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">搜索</el-button>
                <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" :default-sort="{prop: 'userId', order: 'descending'}">
            <el-table-column sortable prop="userId" label="用户id"></el-table-column>
            <el-table-column prop="nickname" label="昵称">
                <template slot-scope="scope">
                    <a v-if="scope.row.nickname" :href="`${frontUrl}/resume/detail/${scope.row.userIdEnc}`" target="_blank">{{scope.row.nickname}}</a>
                    <span v-else>空</span>
                </template>
            </el-table-column>
            <el-table-column label="所属职业">
                <template slot-scope="scope">
                    {{getSkillTagsStr(scope.row.skillTags)}} 
                </template>
            </el-table-column>
            <el-table-column prop="projectExperience" label="工作能力">
                <template slot-scope="scope">
                    {{scope.row.projectExperience || '空'}}
                </template>
            </el-table-column>
            <el-table-column prop="interviewScore" label="面试评分"></el-table-column>
            <el-table-column prop="workYears" label="工作经验">
                <template slot-scope="scope">
                    {{workYearsMap[scope.row.workYears] || '空'}}
                </template>
            </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
            <el-table-column prop="num" label="投递职位数">
                <template slot-scope="scope">
                    <a :href="`/quotes?userBId=${scope.row.userId}`">{{scope.row.num}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="isSpread" label="是否加入推广">
                <template slot-scope="scope">{{scope.row.isSpread ? '是' : '否'}}</template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button-group size="mini">
                        <el-button size="mini" type="success" v-if="scope.row.isShow ==0" @click="showList(scope.row.userId,1)">展示到list</el-button>
                        <el-button size="mini" type="danger" v-if="scope.row.isShow ==1" @click="showList(scope.row.userId,0)">取消展示</el-button>
                        <el-button size="mini" type="success" v-if="!scope.row.resumePushStatus" @click="showIndex(scope.row.userId, 1)">推送至首页</el-button>
                        <el-button size="mini" type="danger" v-else @click="showIndex(scope.row.userId, 0)">取消推送</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :page-count="page" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import request from '../request'
import map from '../../datamap'
import api from '../api'

const url = '/user/listUserByParam'

let {
    user,
    workCateList,
    cate
} = api

const check = '/user/checkUser'
export default {
    name: 'resume-list',
    data() {
        return {
            loading: true,
            list: [],
            user_map: map.user,
            total: 0,
            page: 1,
            limit: 10,
            pageNum: 1,
            filter: {
                userId: '',
                isShow: 0,
                nickname: '',
                phoneNumber: '',
                complete: '',
                isAvatar: '',
                workType: '',
                workTime: '',
                hourWageStart: '',
                hourWageEnd: '',
                quoteStart: '',
                quoteEnd: '',
                jobTitle: '',
                corporateName: '',
                projectName: '',
                degree: '',
                workExperience: null,
                needsId: '',
                isPartyB: '',
                isDeleted: '',
                checkStatus: '',
                skillsTagId: '',
            },
            WorkCateList: [],
            skillsTags: [],
            workYearsMap: {
                1: '一年以下',
                2: '1-3年',
                3: '3-5年',
                4: '5-10年',
                5: '10年以上',
            },
        }
    },
    computed: {
        userBId() {
            return location.search;
        },
    },
    watch: {
        pageNum() {
            this.fetch(2)
        },
    },
    created() {
        this.getWorkCateList()
        this.getCates()
    },
    methods: {
        async fetch(num) {
            if (this.userBId.indexOf("?") != -1) {
                var str = this.userBId.substr(1);
                this.filter.needsId = str.split("=")[1];
            }
            if (num == 1) {
                this.pageNum = 1
            }
            let pageNum = this.pageNum
            let limit = this.limit
            let {
                nickname,
                complete,
                userId,
                phoneNumber,
                isAvatar,
                workType,
                workExperience,
                workTime,
                hourWageStart,
                hourWageEnd,
                quoteStart,
                quoteEnd,
                jobTitle,
                corporateName,
                projectName,
                degree,
                needsId,
                skillsTagId
            } = this.filter
            let res = await user.resumeList({
                pageNum: pageNum,
                limit: limit,
                nickName: nickname,
                complete: complete,
                userId: Number.isInteger(userId) ? userId : '',
                phoneNumber: phoneNumber,
                isAvatar: isAvatar,
                workType: workType,
                workExperience: workExperience,
                workTime: workTime,
                hourWageStart: hourWageStart,
                hourWageEnd: hourWageEnd,
                quoteStart: quoteStart,
                quoteEnd: quoteEnd,
                jobTitle: jobTitle,
                corporateName: corporateName,
                projectName: projectName,
                degree: degree,
                needsId: needsId,
                skillsTagId: skillsTagId
            })
            this.list = res.data.data
            this.total = res.data.pageinfo.totalCount
        },
        async exportExcel() {
            this.loading = true
            let {
                nickname,
                complete,
                userId,
                phoneNumber,
                isAvatar,
                workType,
                workExperience,
                workTime,
                hourWageStart,
                hourWageEnd,
                quoteStart,
                quoteEnd,
                jobTitle,
                corporateName,
                projectName,
                degree,
                needsId,
                skillsTagId
            } = this.filter

            let obj = {
                nickName: nickname,
                complete: complete,
                userId: Number.isInteger(userId) ? userId : '',
                phoneNumber: phoneNumber,
                isAvatar: isAvatar,
                workType: workType,
                workExperience: workExperience,
                workTime: workTime,
                hourWageStart: hourWageStart,
                hourWageEnd: hourWageEnd,
                quoteStart: quoteStart,
                quoteEnd: quoteEnd,
                jobTitle: jobTitle,
                corporateName: corporateName,
                projectName: projectName,
                degree: degree,
                needsId: needsId,
                skillsTagId: skillsTagId
            }
            let resp = await user.exportResumeList(obj)
            let objectUrl = URL.createObjectURL(new Blob([resp.data]))
            let link = document.createElement('a')
            console.log(link)
            link.download = decodeURIComponent('简历列表.xlsx')
            link.href = objectUrl
            link.click()
        },
        async getWorkCateList() {
            let obj = {}
            let res = await workCateList.list(obj);
            this.WorkCateList = res.data.data;
        },
        async showList(userId, isShow) {
            let res = await user.showList({
                userId: userId,
                isShow: isShow
            })
            this.fetch(2);
        },
        async showIndex(userId, isShow) {
            let res = '';
            if (isShow) {
                res = await user.showIndex({
                    userId: userId
                })
            } else {
                res = await user.cancelShowIndex({
                    userId: userId
                })
            }
            if (res.data.code === 200) {
                let msg = isShow ? '已推送到首页' : '已取消首页展示';
                this.$message.success(msg);
                this.fetch(2)
            }
        },
        async remove(item) {
            try {
                await this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                let {
                    userId
                } = item
                let res = await api.user.remove({
                    userId
                })
                if (res.data.code === 200) {
                    this.$message.success('删除数据成功')
                    this.fetch()
                }
            } catch (e) {
                this.$message.success('删除数据失败')
            }
        },
        async update(item) {
            let {
                userId,
                checkStatus
            } = item
            const {
                data: {
                    code
                }
            } = await request.get(check, {
                params: {
                    userId,
                    checkStatus
                }
            })
            if (code === 200) {
                this.$message.success('更新用户成功')
                this.fetch()
            }
        },
        async goDetail(userId) {
            this.$router.push({
                path: `/user-detail?userId=${userId}`
            })
        },
        async getCates() {
            let {
                data: {
                    code,
                    data
                }
            } = await cate.list();
            if (code == 200) {
                this.skillsTags = data;
            } else {
                this.$message.error('获取职业列表失败，请刷新重试！')
            }
        },
        getSkillTagsStr(skillTags) {
            let str = '';
            if (skillTags && skillTags.length) {   
                for(let i=0;i<skillTags.length;i++) {
                    str += skillTags[i].name;
                    str += i == skillTags.length - 1 ? '' : '、';
                }
            }
            return str;
        },
    },
    mounted() {
        this.fetch()
    },
}
</script>
<style>

.fon-tex-coll {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/views/user/resume-list.vue